import { message } from "antd";
import axios from "axios";
import { Dispatch, SetStateAction } from "react";

const BASE_URL = process.env.REACT_APP_API_URL;

export const handleMultiFileUpload = async (
    files: FileList,
    width?: number,
    height?: number,
    id?: any,
    setImageLoading?: Dispatch<SetStateAction<boolean>>
): Promise<string[]> => {
    const urls: string[] = [];

    // Loop through each file
    for (let i = 0; i < files.length; i++) {
        const file = files[i];

        // Create an image object to check dimensions
        const image = new Image();
        image.src = URL.createObjectURL(file);

        // Wrap loading logic in a promise
        const uploadPromise = new Promise<void>((resolve, reject) => {
            image.onload = function () {
                const imgWidth = image.naturalWidth;
                const imgHeight = image.naturalHeight;

                if (
                    (height && imgHeight !== height) ||
                    (width && imgWidth !== width)
                ) {
                    reject(
                        message.error(
                            `Image dimensions must be ${width || "variable"
                            }x${height || "variable"}`
                        )
                    );
                } else {
                    resolve();
                    if (setImageLoading) {
                        setImageLoading(true);
                    }
                }
            };
        });

        // Wait for the uploadPromise to resolve
        await uploadPromise;

        const formData = new FormData();
        formData.append("file", file);
        formData.append("id", id);

        try {
            const response = await axios.post(`${BASE_URL}/app-screen/upload`, formData);
            const url = response.data.preSignedUrl;
            urls.push(url);
            if (setImageLoading) {
                setImageLoading(false);
            }
        } catch (error) {
            console.error("Error uploading file:", error);
            message.error("File(s) not uploaded");
        }
    }

    return urls;
};
